import { Link } from 'react-router-dom';
import { ModalLoading } from '@/components/element/modal/ModalLoading';
import { Footer } from '@/components/layout/Footer';
import brandImg from '@/assets/img/logo_white.svg';

type Props = {
  children?: React.ReactNode;
};

export const SessionLayout = (props: Props) => {
  return (
    <>
      <nav className="navbar navbar-expand-lg position-absolute top-0 z-index-3 w-100 shadow-none my-3 navbar-transparent mt-4">
        <div className="container">
          <span className="navbar-brand font-weight-bolder ms-lg-0 ms-3 text-white">
            <img src={brandImg} className="top-logo-white" />
          </span>
        </div>
      </nav>

      {props.children}

      <Footer />

      <ModalLoading />
    </>
  );
};
